import * as React from "react";
const SvgRegionLine = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "#fff", strokeDasharray: "2 2", strokeOpacity: 0.6, d: "M0 10h20" }));
export default SvgRegionLine;
